const state = reactive({
  job_location: [],
  job_time: [],
  job_categories: [],
  job_level: [],
})

export function useJobCategories() {
  const storyblokApi = useStoryblokApi()
  const { locale } = useI18n()

  async function fetchJobLocation() {
    const { data } = await storyblokApi.get('cdn/stories/', {
      version: 'published',
      starts_with: 'categories/career-categories/job-location/',
      language: locale.value,
    })

    state.job_location = data.stories
  }

  const formattedJobLocation = computed(() =>
    state.job_location.map(({ uuid, name, content }) => ({
      uuid,
      name,
      icon: content.icon,
      value: content.label,
      email: content.email,
    })),
  )

  async function fetchJobTime() {
    const { data } = await storyblokApi.get('cdn/stories/', {
      version: 'published',
      starts_with: 'categories/career-categories/job-time/',
    })

    state.job_time = data.stories
  }

  const formattedJobTime = computed(() =>
    state.job_time.map(({ uuid, name, content }) => ({
      uuid,
      name,
      value: content.label,
    })),
  )

  async function fetchJobCategories() {
    const { data } = await storyblokApi.get('cdn/stories/', {
      version: 'published',
      starts_with: 'categories/career-categories/job-categories/',
      language: locale.value,
    })

    state.job_categories = data.stories
  }

  const formattedJobCategories = computed(() =>
    state.job_categories.map(({ uuid, name, content }) => ({
      uuid,
      name,
      value: content.label,
    })),
  )

  async function fetchJobLevel() {
    const { data } = await storyblokApi.get('cdn/stories/', {
      version: 'published',
      starts_with: 'categories/career-categories/job-level/',
    })

    state.job_level = data.stories
  }

  const formattedJobLevel = computed(() =>
    state.job_level.map(({ uuid, name, content }) => ({
      uuid,
      name,
      value: content.label,
    })),
  )

  return {
    ...toRefs(state),
    fetchJobLocation,
    fetchJobTime,
    fetchJobCategories,
    fetchJobLevel,
    formattedJobLocation,
    formattedJobTime,
    formattedJobCategories,
    formattedJobLevel,
  }
}
